export default {
  path: '/user',
  name: 'user',
  redirect: { name: 'user.settings-page' },
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "user" */ '@/views/user'),
  children: [
    {
      path: '/settings/:tab?',
      name: 'user.settings-page',
      component: () =>
        import(
          /* webpackChunkName: "settings-page" */ '@/views/user/SettingsPage.vue'
        )
    },
    {
      path: '/change/:field',
      name: 'user.change-page',
      meta: { hideFooter: true, fullScreen: true },
      component: () =>
        import(
          /* webpackChunkName: "change-page" */ '@/views/user/ChangePage.vue'
        )
    },
    {
      path: '/messages',
      name: 'user.messages-page',
      component: () =>
        import(
          /* webpackChunkName: "messages-page" */ '@/views/user/MessagesPage.vue'
        )
    },
    {
      path: '/notifications',
      name: 'user.notifications-page',
      component: () =>
        import(
          /* webpackChunkName: "notifications-page" */ '@/views/user/NotificationsPage.vue'
        )
    }
  ]
}
